export const searchTemplates = [
    {
        name: 'Total visits',
        intervals: [
            {
                label: '2w',
                content: event => totalVisitsQuery(event, '2 WEEK'),
            },
            {
                label: '2m',
                content: event => totalVisitsQuery(event, '2 MONTH'),
            },
            {
                label: '1y',
                content: event => totalVisitsQuery(event, '1 YEAR'),
            },
        ],
    },
    {
        name: 'Total visits in context',
        intervals: [
            {
                label: '2w',
                content: event => totalVisitsInContextQuery(event, '2 WEEK'),
            },
            {
                label: '2m',
                content: event => totalVisitsInContextQuery(event, '2 MONTH'),
            },
            {
                label: '1y',
                content: event => totalVisitsInContextQuery(event, '1 YEAR'),
            },
        ],
    },
];
const totalVisitsQuery = (event, interval) => `
SELECT
  COUNT(DISTINCT total_session_id) AS total_visits
FROM
  \`coolblue-marketing-prod.google_analytics_4.events\`
WHERE date BETWEEN DATE_SUB(CURRENT_DATE(), INTERVAL ${interval})
  AND CURRENT_DATE()
  AND event_name = '${event.name}'
  AND feature = '${event.params.feature}'
  AND sub_feature = '${event.params.sub_feature}'
`;
const totalVisitsInContextQuery = (event, interval) => `
SELECT
  COUNT(DISTINCT total_session_id) AS total_visits
FROM
  \`coolblue-marketing-prod.google_analytics_4.events\`
WHERE date BETWEEN DATE_SUB(CURRENT_DATE(), INTERVAL ${interval})
  AND CURRENT_DATE()
  AND event_name = '${event.name}'
  AND feature = '${event.params.feature}'
  AND sub_feature = '${event.params.sub_feature}'
  AND context = '${event.params.context}'
`;
//# sourceMappingURL=SearchTemplates.js.map